require('./da')
require('./de')
require('./en')
require('./fr')
require('./nl')
require('./sv')
require('./nb')
